/**
 * @return {void}
 */
module.exports = function showRoiCalculatorGateContent() {
    document.querySelectorAll('[data-component="roi-calculator-gate-content"]').forEach(roiCalculatorGateContent => {
        if (roiCalculatorGateContent instanceof HTMLElement) {
            roiCalculatorGateContent.style.display = '';
        }
    });
}